var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageAlert48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconAlert48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0 C37.254834,0 48,10.745166 48,24 C47.9848847,37.248568 37.248568,47.9848847 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M24,3.42857143 C12.6387137,3.42857143 3.42857143,12.6387137 3.42857143,24 C3.42857143,35.3612863 12.6387137,44.5714286 24,44.5714286 C35.3612863,44.5714286 44.5714286,35.3612863 44.5714286,24 C44.559146,12.6438052 35.3561948,3.44085402 24,3.42857143 Z M23.9777143,31.5 C25.871262,31.5 27.4062857,33.0350237 27.4062857,34.9285714 C27.4062857,36.8221191 25.871262,38.3571429 23.9777143,38.3571429 C22.0841666,38.3571429 20.5491429,36.8221191 20.5491429,34.9285714 C20.5491429,33.0350237 22.0841666,31.5 23.9777143,31.5 Z M23.9785714,9.59228571 C25.5923475,9.59228571 26.9005714,10.9005097 26.9005714,12.5142857 L26.3245714,27.3668571 C26.3775245,28.2463409 25.9383967,29.0826515 25.1843456,29.5383957 C24.4302946,29.9941399 23.4857054,29.9941399 22.7316544,29.5383957 C21.9776033,29.0826515 21.5384755,28.2463409 21.5914286,27.3668571 L21.0565714,12.5142857 C21.0565714,10.9005097 22.3647954,9.59228571 23.9785714,9.59228571 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#C73500"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAlert48);
export default __webpack_public_path__ + "static/media/messageAlert48.05f928c273b1dcf8c0397142fc8ca4f6.svg";
export { ForwardRef as ReactComponent };